import { render } from "./DetailChain.vue?vue&type=template&id=78710bc6"
import script from "./DetailChain.vue?vue&type=script&lang=js"
export * from "./DetailChain.vue?vue&type=script&lang=js"

import "./DetailChain.vue?vue&type=style&index=0&id=78710bc6&lang=css"
script.render = render

export default script